import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableHighlight,
  KeyboardAvoidingView,
  Dimensions,
  Linking,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Theme from "../argon-ui/Theme";
import { IconButton } from "../components_v2/Buttons";

import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPlus, FONT_FAMILIES } from "../../assets/consts/faCharCodes";

import * as Actions from "../actions/ApiActions";
import { translate } from "../locales/translate";
import Loading from "../components/Loading";
import OrderListItem from "./components/OrderListItem";
import { getIconPicture } from "./components/Icons";
import FilterItem from "../components_v2/FilterItem";
import { englishToPersianNumber } from "../util";
import DateAndTime from "../components/DateAndTime";
import InputBase from "../nativeBase-ui/InputBase";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import { Toast } from "native-base";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import ModalBase from "../nativeBase-ui/ModalBase";
const SCREEN_WIDTH = Dimensions.get("window").width;
class MyOrdersScreen extends Component {
  constructor(props) {
    super(props);
    this.orderTypes = ["ALL"];
    this.orderStatuses = ["ALL"];
    this._sortModes = {
      sortByTime: "orderSortByTime",
      sortByType: "orderSortByType",
      getArray: () => {
        var arr = [];
        for (var i in this._sortModes) {
          if (
            this._sortModes[i] &&
            {}.toString.call(this._sortModes[i]) === "[object Function]"
          ) {
            continue;
          }
          arr.push({
            label: translate(`api.${this._sortModes[i]}`),
            value: this._sortModes[i],
          });
        }
        if (Platform.OS == "web") {
          arr.unshift({
            label: translate("app.orderSortBy"),
            value: "orderSortBy",
          });
        }
        return arr;
      },
    };

    this.state = {
      accessToken: "",
      serverUrl: "",
      isLoading: true,
      orderTypeFilter: "ALL",
      orderStatusFilter: "ALL",
      orderDescriptionFilter: "",
      orderSortFilter: null,
      isLoadingError: false,
      isLoadingPaymentDetails: false,
      paymentDetails: null,
      showModal: 0,
      isNewOrder: true,
      newOrderType: null,
      newOrderUnitId: null,
      isAccessToUnitCredit: false,
      newOrderPaymentItem: null,
      newOrderDescribe: null,
      orderSelected: null,
      orderResponses: [],
      hasOrderResponses: false,
      isShowingCancelAlert: false,
      paymentOnlineUrl: null,
      isOrderRegistering: true,
      isUserValid: "",
      areaList: [],
      reservationUser: null,
      pDateDesired: null,
      pTimeDesiredBegin: null,
      pTimeDesiredEnd: null,
      minHour: 8,
      maxHour: 24,
    };
    this.meetingRoom = 13;
    this.eventRoom = 14;
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.PublicServices"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    var _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl + "/";
    }
    this.setState({ accessToken, serverUrl: _serverUrl }, () => {
      this.getUser().then(() => {
        this.props.MyOrders(accessToken);
        this.props.MyFacilityList(accessToken);
        this.getUserAreas();
        this.setState({ isLoading: false });
      });
    });
  }

  handleOnItemPress = (orderId, orderData) => {
    this.setState({ showModal: 2 });
    this.getOrderResponses(orderId);
    this.setState({ orderSelected: orderData });
  };

  // === show toast => toast native-base ===
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };

  PressOnAddButton = () => {
    this.setState({
      isNewOrder: true,
      newOrderType: null,
      newOrderPaymentItem: null,
      newOrderDescribe: null,
      isOrderRegistering: true,
    });
  };

  hideModal = () => {
    this.setState({
      showModal: 0,
      isNewOrder: true,
      newOrderType: null,
      newOrderPaymentItem: null,
      newOrderDescribe: null,
      orderResponses: false,
      orderSelected: null,
      orderResponses: [],
      hasOrderResponses: false,
      paymentOnlineUrl: null,
      isOrderRegistering: true,
    });
  };
  hideCancelConfirm() {
    this.setState({
      isShowingCancelAlert: false,
    });
  }
  getUserAreas() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRibbonUserInUnit/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ isUserValid: "No" });
        } else {
          var areas = [];
          for (var i in resj) {
            areas.push({
              label: resj[i].strUnitName,
              boolUseUnitCredit: resj[i].boolUseUnitCredit,
              boolIncreaseUnitCredit: resj[i].boolIncreaseUnitCredit,
              value: resj[i].numUnitRef,
            });
          }
          if (Platform.OS == "web") {
            areas.unshift({
              label: translate("api.orderUnit"),
              value: "orderUnit",
            });
          }
          this.setState({
            areaList: areas,
          });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get userInUnit have error ");
          reject(err);
        }
      });
  }
  getFormatNumber(n) {
    "use strict";
    if (Number.isInteger(n)) {
      return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
      return null;
    }
  }

  getUser() {
    return new Promise((resolve, reject) => {
      let { serverUrl, accessToken } = this.state;

      var url = `${serverUrl}Services/GetRibbonUser/`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
            this.setState({ isUserValid: "No" }, () => {
              resolve();
            });
          } else {
            this.setState({ reservationUser: resj, isUserValid: "Yes" });
            resolve();
          }
        })
        .catch((err) => {
          {
            console.log(err, "get user have error ");
            reject(err);
          }
        });
    });
  }

  getRefreshOrderList() {
    this.props.MyOrders(this.state.accessToken);
    this.hideModal();
  }

  cancelOrder() {
    const cancelState = 6;
    if (this.state.orderSelected.numRequestStatus == cancelState) {
      this.showToast(translate("api.canceled"), "info");
      return;
    }
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected.numRequestID}`);
    var url = `${serverUrl}Services/PutOrderCancel/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.cancelNoAccess"));
        } else if (resj.errorCode != null) {
          this.showToast(translate("api.cancelNoAccess"));
        } else {
          this.showToast(translate("api.cancelSuccess"), "success");
          this.getRefreshOrderList();
        }
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.cancelError"));
        }
      });
  }
  getPaymentOnlineUrl() {
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected?.numRequestID}`);
    args.push(
      `paymentType=${this.state.orderSelected?.payment.numPaymentType}`
    );
    args.push(`Amount=${this.state.orderSelected?.numRequestPrice}`);
    args.push(`orderType=${this.state.orderSelected?.numPublicServiceType}`);
    var url = `${serverUrl}Services/GetOnlinePaymentUrl/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errorCode != null) {
          this.showToast(translate("api.orderAnswerError"));
        } else {
          this.setState({ paymentOnlineUrl: resj.paymentUrl }, () => {
            if (Platform.OS === "web") {
              window.open(this.state.paymentOnlineUrl);
            } else {
              Linking.openURL(this.state.paymentOnlineUrl);
            }
          });
        }
      })
      .catch((err) => {
        {
          console.log(err);
        }
      });
  }
  getOrderResponses(orderId) {
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${orderId}`);
    var url = `${serverUrl}Services/GetOrderDetails/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errorCode != null) {
          this.setState({ orderResponses: [], hasOrderResponses: false });
          this.showToast(translate("api.orderAnswerError"));
        } else if (resj.length == 0) {
          this.setState({ orderResponses: [], hasOrderResponses: false });
        } else {
          this.setState({ orderResponses: resj, hasOrderResponses: true });
        }
      })
      .catch((err) => {
        {
          console.log(err);
        }
      });
  }

  getPaymentMethod() {
    if (
      this.state.newOrderType != null &&
      Number.isInteger(this.state.newOrderType) &&
      this.state.newOrderUnitId != null &&
      Number.isInteger(this.state.newOrderUnitId)
    ) {
      this.setState({
        isLoadingPaymentDetails: true,
        newOrderPaymentItem: null,
        newOrderDescribe: null,
      });

      let { serverUrl, accessToken } = this.state;
      let args = [];
      args.push(`UnitCode=${this.state.newOrderUnitId}`);
      args.push(`PublicServiceType=${this.state.newOrderType}`);

      var url = `${serverUrl}Services/GetPaymentDetails/?${args.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          this.setState({ isLoadingPaymentDetails: false });
          if (resj.errors == "NoAccess") {
            this.showToast(translate("api.serviceNoAccess"));
          } else if (resj.errors != null) {
            this.showToast(translate("api.getPaymentDetailsError"));
          } else {
            this.setState({ paymentDetails: resj, isNewOrder: false });
          }
        })
        .catch((err) => {
          {
            console.log(err);
            this.setState({ isLoadingPaymentDetails: false });
            // this.showModalToast(translate("api.getPaymentDetailsError"));
          }
        });
    } else {
      this.showToast(translate("api.requireTypeUnit"));
    }
  }

  registerNewOrder() {
    if (
      this.state.newOrderPaymentItem != null &&
      Number.isInteger(this.state.newOrderPaymentItem) &&
      this.state.newOrderType != null &&
      Number.isInteger(this.state.newOrderType) &&
      this.state.newOrderUnitId != null &&
      Number.isInteger(this.state.newOrderUnitId)
    ) {
      let { serverUrl, accessToken } = this.state;
      let args = [];

      args.push(`UnitCode=${this.state.newOrderUnitId}`);
      args.push(`PublicServiceType=${this.state.newOrderType}`);
      if (this.state.newOrderDescribe) {
        args.push(`RequestDesc=${this.state.newOrderDescribe}`);
      } else {
        args.push(`RequestDesc=${"-"}`);
      }
      args.push(`PaymentType=${this.state.newOrderPaymentItem}`);
      args.push(`Amount=${this.state.paymentDetails.price}`);
      if (
        this.state.newOrderType == this.meetingRoom ||
        this.state.newOrderType == this.eventRoom
      ) {
        args.push(`PdateDesired=${this.state.pDateDesired}`);
        args.push(`PTimeDesiredBegin=${this.state.pTimeDesiredBegin}`);
        args.push(`PTimeDesiredEnd=${this.state.pTimeDesiredEnd}`);
      }

      var url = `${serverUrl}Services/PostRegisterOrder/?${args.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errorCode != null) {
            this.setState({ isOrderRegistering: true });
            this.showToast(resj.errorMessage);
          } else {
            if (this.state.newOrderPaymentItem != 4) {
              this.hideModal();
              this.props.MyOrders(this.state.accessToken);
              // this.showModalToast(translate("api.RegisteredNewOrder"));
            } else if (this.state.newOrderPaymentItem == 4)
              this.setState({ paymentOnlineUrl: resj.paymentUrl }, () => {
                if (Platform.OS === "web") {
                  window.open(this.state.paymentOnlineUrl);
                } else {
                  Linking.openURL(this.state.paymentOnlineUrl);
                }
              });
            if (this.props.reducer.confirm) {
              this.showToast(translate("api.registeredNewOrder"), "success");
              this.hideModal();
              this.props.MyOrders(this.state.accessToken);
            } else {
              this.showToast(
                translate("api.noPaymentOnlineSuccessFul"),
                "info"
              );
              this.hideModal();
              this.props.MyOrders(this.state.accessToken);
            }
          }
        })
        .catch((err) => {
          {
            console.log(err);
          }
        });
    } else {
      this.showToast(translate("api.requirePaymentMethod"));
    }
    this.setState({ isOrderRegistering: true });
  }
  render() {
    // if (this.state.isLoading) {
    //   return <Loading message={translate("app.pleaseWaite")} />;
    // } else
    if (this.state.isUserValid == "No") {
      return (
        <View
          style={{ alignItems: "center", flex: 1, justifyContent: "center" }}
        >
          <Text style={{ fontSize: 20, color: "#666666" }}>
            {translate("api.invalidUserReserveApi")}
          </Text>
        </View>
      );
    } else if (this.state.isLoading || this.props.reducer.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else if (this.state.isLoadingError) {
      return (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <Text
            style={{
              color: Theme.COLORS.ERROR,
              textAlign: "center",
            }}
          >
            {translate("app.loadingError")}
          </Text>
        </View>
      );
    }

    var orderList = [];
    var hasOrder = undefined;
    const shortSupply = 7;
    const underInvestigation = 2;
    var allOrderList = this.props.reducer.list;
    orderList = allOrderList.filter((o) => {
      if (
        (this.state.orderTypeFilter == "ALL" ||
          this.state.orderTypeFilter == o.data.strServicesName) &&
        (this.state.orderStatusFilter == "ALL" ||
          o.data.numRequestStatus == this.state.orderStatusFilter ||
          (this.state.orderStatusFilter == underInvestigation &&
            o.data.numRequestStatus == shortSupply)) &&
        (!this.state.orderDescriptionFilter ||
          o.data.strRequestDesc.indexOf(this.state.orderDescriptionFilter) >= 0)
      )
        return o;
    });
    orderList.sort((a, b) =>
      a.dtPDate < b.dtPDate ? 1 : a.dtPTime < b.dtPTime ? 1 : -1
    );

    if (this.props.reducer.list.length == 0) {
      hasOrder = "No";
    }
    if (this.props.reducer.list.length != 0) {
      hasOrder = "Yes";
    }
    // orderStatuses
    if (allOrderList && allOrderList.length > 0) {
      this.orderStatuses = ["ALL"];
      for (var i in allOrderList) {
        var status = allOrderList[i].data.numRequestStatus;
        if (this.orderStatuses.indexOf(status) < 0 && status != shortSupply) {
          this.orderStatuses.push(status);
        }
        if (status == shortSupply) {
          this.orderStatuses.push(underInvestigation);
        }
      }
    }

    // orderTypes
    switch (this.state.orderSortFilter) {
      case this._sortModes.sortByTime:
        orderList.sort((a, b) =>
          a.orderTime > b.orderTime ? 1 : a.dtPTime > b.dtPTime ? 1 : -1
        );
        break;
      case this._sortModes.sortByType:
        orderList.sort((a, b) =>
          a.data.strServicesName > b.data.strServicesName ? 1 : -1
        );
        break;
    }
    if (orderList && orderList.length > 0) {
      for (var i in orderList) {
        var typ = orderList[i].data.strServicesName;
        if (this.orderTypes.indexOf(typ) < 0) {
          this.orderTypes.push(typ);
        }
      }
    }

    var facilityList = [];
    for (var i in this.props.reducer.facilityList) {
      if (this.props.reducer.facilityList[i].isActive) {
        facilityList.push({
          label:
            this.props.reducer.facilityList[i].data.strPublicServiceTypeName,
          value: this.props.reducer.facilityList[i].id,
        });
      }
    }

    if (Platform.OS == "web") {
      facilityList.unshift({
        label: translate("api.orderSortByType"),
        value: "orderSortByType",
      });
    }

    // CreditUnitPayment
    var paymentType_Options = [];
    const unitBalance = 1;
    const userBalance = 2;
    const cashPayment = 3;
    const onlinePayment = 4;
    var hasCredit = false;
    if (this.state.paymentDetails != null) {
      if (this.state.paymentDetails.cashPayment) {
        paymentType_Options.push({
          value: cashPayment,
          label: `${translate("api.cashPayment")}`,
        });
      }
      hasCredit = true;
      if (this.state.paymentDetails.onlinePayment) {
        paymentType_Options.push({
          value: onlinePayment,
          label: `${translate("api.onlinePayment")}`,
        });
      }
      if (
        this.state.paymentDetails.creditUnitPayment &&
        this.state.paymentDetails.unitBalance != null &&
        this.state.paymentDetails.unitBalance >= this.state.paymentDetails.price
      ) {
        paymentType_Options.push({
          value: unitBalance,
          label: `${translate(
            "api.creditUnitPayment"
          )} (${englishToPersianNumber(
            this.state.paymentDetails.unitBalance,
            ","
          )} ${translate("api.priceUnit")} )`,
        });
        hasCredit = true;
      }

      if (
        this.state.paymentDetails.creditUserPayment &&
        this.state.paymentDetails.userBalance >= this.state.paymentDetails.price
      ) {
        paymentType_Options.push({
          value: userBalance,
          label: `${translate(
            "api.creditUserPayment"
          )} (${englishToPersianNumber(
            this.state.paymentDetails.userBalance,
            ","
          )} ${translate("api.priceUnit")} )`,
        });
        hasCredit = true;
      }
      if (Platform.OS == "web") {
        paymentType_Options.unshift({
          label: translate("api.paymentType"),
          value: "paymentType",
        });
      }
    }
    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        {this.state.isUserValid == "Yes" && (
          <View style={{ flex: 1 }}>
            {/* TouchableFilters */}
            <FilterItem
              listItem={this.orderTypes.map((s) => {
                return { value: s, text: translate(`api.orderTypes.${s}`) };
              })}
              selectedItem={this.state.orderTypeFilter || this.orderType[0]}
              onSelect={(item) => {
                this.setState({
                  orderTypeFilter: item,
                });
              }}
            />
            <FilterItem
              listItem={this.orderStatuses.map((s) => {
                return { value: s, text: translate(`api.orderStatuses.${s}`) };
              })}
              selectedItem={
                this.state.orderStatusFilter || this.orderStatuses[0]
              }
              onSelect={(item) => {
                this.setState({ orderStatusFilter: item });
              }}
            />
            {/* Filters */}
            <View
              style={{
                // flexDirection: "row",
                // paddingStart: 10,
                paddingEnd: 10,
                paddingTop: 5,
                paddingStart: 10,
                // height: 67,
                backgroundColor: Theme.COLORS.BORDER_COLOR,
                borderBottomWidth: 1,
                borderColor: Theme.COLORS.BORDER,
              }}
            >
              <InputSearch
                placeholder={translate("app.searchInOrderDetails")}
                value={this.state.orderDescriptionFilter}
                onChangeText={(txt) => {
                  this.setState({ orderDescriptionFilter: txt });
                }}
              />

              <View style={{ flex: 1, marginVertical: 5 }}>
                <Select
                  data={this._sortModes.getArray()}
                  value={
                    Platform.OS == "web"
                      ? this.state.orderSortFilter
                      : translate("app.orderSortBy") ||
                        this.state.orderSortFilter
                  }
                  onChangeText={(value, index, data) => {
                    this.setState({ orderSortFilter: value });
                  }}
                />
              </View>
            </View>
            {hasOrder == "Yes" && orderList.length != 0 && (
              <ScrollView
                style={{
                  flex: 1,
                  marginBottom: 85,
                }}
              >
                {orderList.map((o, i) => {
                  return (
                    <OrderListItem
                      onPress={() => this.handleOnItemPress(o.id, o.data)}
                      key={i}
                      orderData={o.data}
                      toast={this.showToast}
                    />
                  );
                })}
              </ScrollView>
            )}

            {hasOrder == "No" && orderList.length == 0 && (
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                {!this.state.reservationUser?.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.disabledReservationUser")}
                  </Text>
                )}
                {this.state.reservationUser?.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.noOrderRequest")}
                  </Text>
                )}
              </View>
            )}
            {this.state.reservationUser?.boolUserStatus &&
              facilityList.length != 0 && (
                <TouchableHighlight
                  onPress={
                    (this.PressOnAddButton,
                    () => this.setState({ showModal: 1 }))
                  }
                  color="primary"
                  iconColor="#fff"
                  shadowColor={true}
                  style={style.btnAdd}
                >
                  <FontAwesomeIcon icon={faPlus} color="#FFF" size={23} />
                </TouchableHighlight>
              )}
            {facilityList.length == 0 && (
              <View
                style={{
                  height: 60,
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: -70,
                  marginBottom: 10,
                }}
              >
                <Text style={{ fontWeight: "bold", fontSize: 18 }}>
                  {translate("api.inactiveService")}
                </Text>
              </View>
            )}

            {/* new order */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 1}
              onClose={() => this.hideModal()}
            >
              <View
                style={{
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  borderRadius: 5,
                  marginTop: 15,
                  flex: 1,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 7,
                  }}
                >
                  {this.state.newOrderType != null && (
                    <IconButton
                      // onPress={() => this.navigateToService(item.name)}
                      style={{
                        backgroundColor: "#ffffff",
                        width: 70,
                        height: 70,
                        borderRadius: 35,
                        borderWidth: 1,
                        borderColor: "#ccf",
                        marginStart: 22,
                        marginEnd: 22,
                        // paddingTop:15
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      icon={{
                        code: getIconPicture(
                          "facilityIcons",
                          this.state.newOrderType
                        ),
                        style: {
                          fontFamily: FONT_FAMILIES.PRO_REGULAR,
                          fontSize: 30,
                          color: getIconPicture(
                            "facilityIcons",
                            this.state.newOrderType
                          )
                            ? "#006666"
                            : "#ccc",
                        },
                      }}
                    />
                  )}
                  {this.state.newOrderType == null && (
                    <IconButton
                      // onPress={() => this.navigateToService(item.name)}
                      style={{
                        backgroundColor: "#ffffff",
                        width: 70,
                        height: 70,
                        borderRadius: 35,
                        borderWidth: 1,
                        borderColor: "#ccf",
                        marginStart: 22,
                        marginEnd: 22,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      icon={{
                        code: getIconPicture(
                          "facilityIcons",
                          this.state.newOrderType
                        ),
                        style: {
                          fontFamily: FONT_FAMILIES.PRO_REGULAR,
                          fontSize: 30,
                          color: getIconPicture(
                            "facilityIcons",
                            this.state.newOrderType
                          )
                            ? "#006666"
                            : "#ccc",
                        },
                      }}
                    />
                  )}
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <View style={{ flex: 3, padding: 10 }}>
                    <Select
                      label={null}
                      data={facilityList}
                      value={
                        Platform.OS == "web"
                          ? this.state.newOrderType
                          : translate("api.orderSortByType") ||
                            this.state.newOrderType
                      }
                      onChangeText={(value, index, data) => {
                        // this.setState({ isNewOrder: true });
                        if (
                          (Number.isInteger(value) || Number(value) > 0) &&
                          Number(value) != this.state.newOrderType
                        ) {
                          this.setState({
                            isNewOrder: true,
                            newOrderType: Number(value),
                            paymentOnlineUrl: null,
                            pTimeDesiredEnd: null,
                            pTimeDesiredBegin: null,
                            pDateDesired: null,
                          });
                        }
                      }}
                    />
                  </View>
                  <View style={{ flex: 2, padding: 10 }}>
                    <Select
                      label={null}
                      data={this.state.areaList}
                      value={
                        Platform.OS == "web"
                          ? this.state.newOrderUnitId
                          : translate("api.orderUnit") ||
                            this.state.newOrderUnitId
                      }
                      onChangeText={(value, index, data) => {
                        this.setState({ isNewOrder: true });
                        if (Number.isInteger(value) || Number(value) > 0) {
                          this.setState({
                            newOrderUnitId: Number(value),
                            isAccessToUnitCredit: this.state.areaList.map(
                              (i) => i.value == value
                            )?.boolUseUnitCredit,
                          });
                        }
                      }}
                    />
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 7,
                    height: 250,
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      borderColor: Theme.COLORS.BORDER,
                      borderRadius: 4,
                      borderWidth: 1,
                      padding: 10,
                      minHeight: 200,
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    <Loading
                      style={{
                        display: this.state.isLoadingPaymentDetails
                          ? "flex"
                          : "none",
                        margin: 3,
                      }}
                      imageStyle={{ height: 80, padding: 3 }}
                      message={translate("app.pleaseWaite")}
                    />
                    <TouchableHighlight
                      underlayColor={Theme.COLORS.BORDER}
                      onPress={() => this.getPaymentMethod()}
                      style={{
                        borderColor: Theme.COLORS.BORDER,
                        borderWidth: 1,
                        backgroundColor: "#fff",
                        borderRadius: 3,
                        height: 37,
                        padding: 9,
                        width: 150,
                        display:
                          this.state.isNewOrder &&
                          !this.state.isLoadingPaymentDetails
                            ? "flex"
                            : "none",
                      }}
                    >
                      <Text style={{ textAlign: "center" }}>
                        {translate("api.paymentMethod")}
                      </Text>
                    </TouchableHighlight>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        height: 800,
                        width: "100%",
                        display:
                          !this.state.isLoading && !this.state.isNewOrder
                            ? "flex"
                            : "none",
                      }}
                    >
                      {(Number(this.state.newOrderType) == this.meetingRoom ||
                        Number(this.state.newOrderType) == this.eventRoom) && (
                        <DateAndTime
                          defaultDate={null}
                          minHour={this.state.minHour}
                          maxHour={this.state.maxHour}
                          selectedDate={(date) => {
                            this.setState({ pDateDesired: date });
                          }}
                          selectedStartTime={(startTime) => {
                            this.setState({ pTimeDesiredBegin: startTime });
                          }}
                          selectedEndTime={(endTime) =>
                            this.setState({ pTimeDesiredEnd: endTime })
                          }
                        ></DateAndTime>
                      )}
                      <View
                        style={{
                          display: hasCredit ? "flex" : "none",
                          alignItems: "center",
                        }}
                      >
                        {this.state.paymentDetails != null && (
                          <Text>
                            {translate("api.servicePrice").concat(": ")}
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {englishToPersianNumber(
                                this.state.paymentDetails.price,
                                ","
                              )}{" "}
                            </Text>
                            <Text>{translate("api.priceUnit")} </Text>
                          </Text>
                        )}
                        <View
                          style={{
                            marginTop: 8,
                            height: 37,
                            width: "100%",
                            marginBottom: 10,
                          }}
                        >
                          <Select
                            label={null}
                            data={paymentType_Options}
                            value={
                              Platform.OS == "web"
                                ? this.state.newOrderPaymentItem
                                : translate("api.paymentType") ||
                                  this.state.newOrderPaymentItem
                            }
                            onChangeText={(value, index, data) => {
                              if (Number(value) > 0) {
                                this.setState({
                                  newOrderPaymentItem: Number(value),
                                });
                              }
                            }}
                          />
                        </View>
                        <View
                          style={{
                            alignItems: "stretch",
                            width: "100%",
                            paddingTop: 8,
                          }}
                        >
                          <InputSearch
                            label={translate("api.orderDescription")}
                            value={this.state.newOrderDescribe}
                            onChangeText={(text) => {
                              this.setState({ newOrderDescribe: text });
                            }}
                          />
                        </View>
                        <View
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <TouchableHighlight
                            onPress={() => {
                              if (this.state.isOrderRegistering) {
                                this.setState(
                                  { isOrderRegistering: false },
                                  this.registerNewOrder()
                                );
                              }
                            }}
                            underlayColor={Theme.COLORS.BORDER}
                            style={{
                              borderColor: Theme.COLORS.BORDER,
                              borderWidth: 1,
                              backgroundColor: "#fff",
                              borderRadius: 3,
                              height: 37,
                              padding: 9,
                              width: 150,
                              marginTop: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Text style={{ textAlign: "center" }}>
                              {(this.state.newOrderPaymentItem != 4 &&
                                translate("api.registration")) ||
                                (this.state.newOrderPaymentItem == 4 &&
                                  translate("api.registration&Payment"))}
                            </Text>
                          </TouchableHighlight>
                        </View>
                      </View>
                      <Text
                        style={{
                          fontFamily: "IRANSansWebFaNum",
                          textAlign: "center",
                          display: !hasCredit ? "flex" : "none",
                        }}
                      >
                        {`${translate("api.noCredit")}`}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </ModalBase>
            {/* details */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 2}
              onClose={() => this.hideModal()}
            >
              <View style={style.modalInsideWrapper}>
                <View
                  style={
                    Platform.OS == "web"
                      ? style.webModalDetails
                      : style.appModalDetails
                  }
                >
                  {/* start Icons */}
                  <View
                    style={{
                      flexDirection: "row",
                      borderColor: Theme.COLORS.BORDER,
                      borderBottomWidth: 1,
                      height: 77,
                      width: "100%",
                    }}
                  >
                    {this.state.orderSelected != null && (
                      <IconButton
                        style={{
                          backgroundColor: "#ffffff",
                          width: 70,
                          height: 70,
                          borderRadius: 35,
                          borderWidth: 1,
                          borderColor: "#ccf",
                          marginStart: 22,
                          marginEnd: 22,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={{
                          code: getIconPicture(
                            "facilityIcons",
                            this.state.orderSelected.numPublicServiceType
                          ),
                          style: {
                            fontFamily: FONT_FAMILIES.PRO_REGULAR,
                            fontSize: 30,
                            color: getIconPicture(
                              "facilityIcons",
                              this.state.orderSelected.numPublicServiceType
                            )
                              ? "#006666"
                              : "#ccc",
                          },
                        }}
                      />
                    )}
                    <View
                      style={{
                        flex: 1,
                        marginTop: 5,
                        flexDirection: "column",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text style={{ paddingTop: 8 }}>
                            {translate("api.orderId")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.numRequestID,
                                ""
                              )}
                            </Text>
                          </Text>
                        )}

                        {this.state.orderSelected != null && (
                          <Text style={{ paddingTop: 10 }}>
                            {this.state.orderSelected.strUnitName}
                          </Text>
                        )}
                      </View>
                      {this.state.orderSelected != null && (
                        <Text style={{ marginTop: 6 }}>
                          {translate("api.orderSelectedType")} :{" "}
                          {this.state.orderSelected.strPublicServiceTypeName}
                        </Text>
                      )}
                    </View>
                    {this.state.orderSelected != null && (
                      <IconButton
                        style={{
                          // marginBottom: 20,
                          marginEnd: 20,
                          marginStart: 20,
                          backgroundColor: "#ffffff",
                          width: 70,
                          height: 70,
                          borderRadius: 35,
                          borderWidth: 1,
                          borderColor: "#ccf",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={{
                          code: getIconPicture(
                            "statusOrder",
                            this.state.orderSelected.numRequestStatus
                          ),
                          style: {
                            fontFamily: FONT_FAMILIES.PRO_REGULAR,
                            fontSize: 30,
                            color: "#999",
                          },
                        }}
                      />
                    )}
                  </View>
                  {/* texts */}
                  <View
                    style={{
                      // flex: 1,
                      flexDirection: "column",
                      width: "85%",
                      paddingEnd: Platform.OS == "web" ? 0 : 20,
                      paddingStart: Platform.OS == "web" ? 0 : 20,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                        paddingStart: 7,
                        paddingEnd: 7,
                        paddingTop: 5,
                      }}
                    >
                      {this.state.orderSelected != null && (
                        <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                          {translate("api.orderStatus")}:
                          {this.state.orderSelected.strRequestStatus}
                        </Text>
                      )}
                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.orderSelectedDate")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.dtPDate
                              )}
                            </Text>
                          </Text>
                        )}
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.orderSelectedTime")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.dtPTime
                              )}
                            </Text>
                          </Text>
                        )}
                      </View>
                      {this.state.orderSelected != null && (
                        <View
                          style={{
                            alignItems: "flex-end",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Text
                            style={{
                              alignItems: "flex-end",
                              fontWeight: "bold",
                            }}
                          >
                            {translate("api.orderPrice")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.numRequestPrice,
                                ","
                              )}{" "}
                            </Text>
                            <Text>{translate("api.priceUnit")}</Text>
                          </Text>
                          {this.state.orderSelected.payment.numPaymentStatus ==
                            0 &&
                            this.state.orderSelected.payment.numPaymentType ==
                              4 &&
                            (this.state.orderSelected.numRequestStatus == 1 ||
                              this.state.orderSelected.numRequestStatus == 2 ||
                              this.state.orderSelected.numRequestStatus == 7) &&
                            this.state.reservationUser.boolUserStatus && (
                              <TouchableHighlight
                                underlayColor={Theme.COLORS.BORDER}
                                onPress={() => {
                                  this.getPaymentOnlineUrl();
                                }}
                                style={{
                                  borderColor: Theme.COLORS.BORDER,
                                  borderWidth: 1,
                                  backgroundColor: "#fff",
                                  borderRadius: 3,
                                  height: 33,
                                  // marginBottom: 15,
                                  padding: 9,
                                  // marginEnd: 30,
                                  width: 120,
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Text style={{ textAlign: "center" }}>
                                  {translate("api.onlinePayment")}
                                </Text>
                              </TouchableHighlight>
                            )}
                        </View>
                      )}
                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.paymentTypeString")}
                            {": "}
                            {translate(
                              "api.paymentTypeCode".concat(
                                ".",
                                this.state.orderSelected.payment.numPaymentType
                              )
                            )}
                          </Text>
                        )}
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.paymentStatusString")}
                            {": "}
                            {translate(
                              "api.paymentStatusCode".concat(
                                ".",
                                this.state.orderSelected.payment
                                  .numPaymentStatus
                              )
                            )}
                          </Text>
                        )}
                      </View>
                    </View>
                    {this.state.orderSelected != null && (
                      <View style={{ height: 20 }}>
                        <InputBase
                          isDisabled={true}
                          value={
                            this.state.orderSelected != null &&
                            this.state.orderSelected.strRequestDesc
                          }
                          label={translate("api.orderDescription")}
                        />
                      </View>
                    )}
                  </View>
                  {/* responses */}
                  <View
                    style={{
                      flex: 2,
                      width: SCREEN_WIDTH * 0.8,
                      flexDirection: "column",
                      paddingBottom: 10,
                      height: 80,
                      marginBottom: 0,
                    }}
                  >
                    {this.state.orderResponses.length != 0 && (
                      <ScrollView
                        contentInset={{ top: 2, left: 4, bottom: 2, right: 4 }}
                        style={{
                          borderColor: Theme.COLORS.BORDER,
                          borderWidth: 1,
                          borderRadius: 4,
                        }}
                        contentContainerStyle={{
                          paddingVertical: 20,
                          padding: 5,
                          marginHorizontal: 1,
                          padding: 3,
                          borderRadius: 4,
                          borderColor: Theme.COLORS.BORDER,
                        }}
                      >
                        {this.state.orderResponses.map((o, i) => {
                          return (
                            <View
                              style={{
                                flexDirection: "row",
                                paddingTop: 3,
                                paddingBottom: 3,
                                borderBottomColor: Theme.COLORS.BORDER,
                                borderBottomWidth: 1,
                              }}
                              key={i}
                            >
                              <View
                                style={{
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  paddingBottom: 3,
                                }}
                              >
                                <Text style={{ margin: 2 }}>
                                  {translate("api.replier")}:{" "}
                                  {o.strResponderName}
                                </Text>
                                {o?.dtPDate && (
                                  <Text>
                                    {translate("api.orderResponse")}:
                                    {englishToPersianNumber(o?.dtPDate)}
                                  </Text>
                                )}
                                <Text>
                                  {translate("api.response")}: {o.strAnswer}
                                </Text>
                              </View>
                            </View>
                          );
                        })}
                      </ScrollView>
                    )}
                    <Text
                      style={{
                        marginStart: 50,
                        marginTop: 50,
                        display: !this.state.hasOrderResponses
                          ? "flex"
                          : "none",
                      }}
                    >
                      {translate("api.orderNoAnswer")}
                    </Text>
                  </View>
                  {/* end buttons */}
                  <View
                    style={{
                      alignItems: "center",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <View
                      style={{
                        // paddingEnd: 10,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {(this.state.orderSelected?.numRequestStatus == 1 ||
                        this.state.orderSelected?.numRequestStatus == 2 ||
                        this.state.orderSelected?.numRequestStatus == 7) && (
                        <TouchableHighlight
                          underlayColor={Theme.COLORS.BORDER}
                          onPress={() => {
                            this.setState({ isShowingCancelAlert: true });
                          }}
                          style={{
                            borderColor: Theme.COLORS.BORDER,
                            borderWidth: 1,
                            backgroundColor: "#fff",
                            borderRadius: 3,
                            height: 37,
                            marginBottom: 15,
                            padding: 9,
                            marginEnd: 30,
                            width: 150,
                          }}
                        >
                          <Text style={{ textAlign: "center" }}>
                            {translate("app.alertTitleCancel")}
                          </Text>
                        </TouchableHighlight>
                      )}
                      <TouchableHighlight
                        underlayColor={Theme.COLORS.BORDER}
                        onPress={() => this.hideModal()}
                        style={{
                          borderColor: Theme.COLORS.BORDER,
                          borderWidth: 1,
                          backgroundColor: "#fff",
                          borderRadius: 3,
                          height: 37,
                          marginBottom: 15,
                          padding: 9,
                          width: 150,
                        }}
                      >
                        <Text style={{ textAlign: "center" }}>
                          {translate("api.closeOrderSelected")}
                        </Text>
                      </TouchableHighlight>
                      {this.state.isShowingCancelAlert && (
                        <AlertDialogBase
                          isOpen={true}
                          title={translate("app.alertTitleCancel")}
                          confirmText={translate("app.confirm")}
                          colorConfirm="primary"
                          confirmHandler={() => {
                            this.cancelOrder();
                            this.hideCancelConfirm();
                          }}
                          onClose={() => {
                            this.hideCancelConfirm();
                          }}
                        >
                          <Text>{translate("api.isConfirmCancel")}</Text>
                        </AlertDialogBase>
                      )}
                    </View>
                  </View>
                </View>
              </View>
            </ModalBase>
          </View>
        )}
      </KeyboardAvoidingView>
    );
  }
}

const style = StyleSheet.create({
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginBottom: 16,
    marginTop: 16,
  },
  webModalDetails: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 380,
    marginTop: 7,
    width: "100%",
  },
  appModalDetails: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 380,
    marginTop: 7,
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  modalInsideWrapper: {
    backgroundColor: "#FFF",
    borderRadius: 10,
    margin: 0,
    marginBottom: 0,
    paddingTop: 15,
    alignItems: "center",
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.ApiReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    MyOrders: (accessToken) => dispatch(Actions.MyOrders(accessToken)),
    MyFacilityList: (accessToken) =>
      dispatch(Actions.MyFacilityList(accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrdersScreen);
